export default "__VITE_ASSET__Cts$6Yrr__"